import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewEncapsulation, Input, ViewChild, Output, NgModule } from '@angular/core';
import videojs from 'video.js';

class VideoPlayerComponent {
    constructor() {
        this.videoEnded = new EventEmitter();
        this.videoStarted = new EventEmitter();
        this.playerReady = new EventEmitter();
        this.defaultOptions = {
            fluid: true,
            aspectRatio: '16:9',
            controls: true,
            autoplay: false,
            techOrder: ['html5'],
        };
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this._options = { ...this.defaultOptions, ...options };
    }
    ngAfterViewInit() {
        this.videoPlayer = videojs(this.container.nativeElement, this.options);
        this.videoPlayer.on('ended', e => {
            this.videoEnded.emit();
        });
        this.videoPlayer.on('playing', () => {
            this.videoStarted.emit();
        });
        this.videoPlayer.on('loadstart', e => {
            this.playerReady.emit();
        });
    }
    setSource(source) {
        this.videoPlayer.src(source);
        this.videoPlayer.autoplay(true);
    }
    stop() {
        this.videoPlayer.pause();
    }
    ngOnDestroy() {
        if (this.videoPlayer) {
            this.videoPlayer.dispose();
        }
    }
}
VideoPlayerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: VideoPlayerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
VideoPlayerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.8", type: VideoPlayerComponent, selector: "cc-video-player", inputs: { options: "options" }, outputs: { videoEnded: "videoEnded", videoStarted: "videoStarted", playerReady: "playerReady" }, viewQueries: [{ propertyName: "container", first: true, predicate: ["container"], descendants: true, static: true }], ngImport: i0, template: `
    <video
      #container
      class="video-js vjs-default-skin vjs-big-play-centered"
      controlsList="nodownload"
      oncontextmenu="return false"
    ></video>
  `, isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: VideoPlayerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cc-video-player',
                    template: `
    <video
      #container
      class="video-js vjs-default-skin vjs-big-play-centered"
      controlsList="nodownload"
      oncontextmenu="return false"
    ></video>
  `,
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { options: [{
                type: Input
            }], container: [{
                type: ViewChild,
                args: ['container', { static: true }]
            }], videoEnded: [{
                type: Output
            }], videoStarted: [{
                type: Output
            }], playerReady: [{
                type: Output
            }] } });

class VideoPlayerModule {
}
VideoPlayerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: VideoPlayerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
VideoPlayerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.2.8", ngImport: i0, type: VideoPlayerModule, declarations: [VideoPlayerComponent], exports: [VideoPlayerComponent] });
VideoPlayerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: VideoPlayerModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.8", ngImport: i0, type: VideoPlayerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [VideoPlayerComponent],
                    imports: [],
                    exports: [VideoPlayerComponent]
                }]
        }] });

/*
 * Public API Surface of video-player
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VideoPlayerComponent, VideoPlayerModule };
